import { Alert, Button, Container, Form, InputGroup, Modal } from 'react-bootstrap';
import { Topbar } from '../../components/Topbar/Topbar';
import { Footer } from '../../components/Footer/Footer';
import { FormEvent, useState } from 'react';
import { useFirebase } from '../../../contexts/FirebaseContext';
import { useTranslation } from 'react-i18next';
import { Title } from '../../components/Title/Title';

const TVComponent = () => {
  const { consumeTvLoginCode, subscription } = useFirebase();
  const [loading, setLoading] = useState(false);
  const [code, setCode] = useState('');
  const [resultModalOpen, setResultModalOpen] = useState(false);
  const [result, setResult] = useState<boolean>(null);
  const { t } = useTranslation();

  const submitLoginCode = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    setResultModalOpen(false);
    setResult(null);
    consumeTvLoginCode(code).then((result) => {
      setLoading(false);
      setResult(result);
      setResultModalOpen(true);
    });
  };

  return (
    <>
      <Title>{t('tv.labels.title')}</Title>

      <div style={{ marginBottom: '72px' }}>
        <div style={{ backgroundColor: '#141414', position: 'fixed', top: '0', left: '0', right: '0', zIndex: 100 }}>
          <Topbar />
        </div>
      </div>

      <Container className={'my-5'}>
        {!!subscription ? (
          <Form onSubmit={submitLoginCode} className={'d-flex justify-content-center'}>
            <InputGroup size={'lg'} style={{ maxWidth: '500px' }}>
              <Form.Control
                value={code}
                onChange={(e) => setCode(e.target.value)}
                required
                autoFocus
                placeholder={t('tv.labels.inserisciCodice')}
                maxLength={6}
                minLength={6}
              />
              <InputGroup.Append>
                <Button variant={'primary'} type={'submit'} disabled={loading}>
                  {t('labels.conferma')}
                </Button>
              </InputGroup.Append>
            </InputGroup>
          </Form>
        ) : (
          <Alert variant={'warning'} className={'mb-0'}>
            {t('tv.labels.necessarioAbbonamentoAttivo')}
          </Alert>
        )}
      </Container>

      <Footer />

      <Modal show={resultModalOpen} onHide={() => setResultModalOpen(false)}>
        <Modal.Header>
          <Modal.Title>{result ? t('tv.labels.operazioneSuccesso') : t('errorModal.labels.codiceNonValido')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {result && <div>{t('tv.labels.codiceValido')}</div>}
          {!result && <div>{t('tv.labels.codiceNonValido')}</div>}
        </Modal.Body>
        <Modal.Footer>
          <Button variant={'primary'} onClick={() => setResultModalOpen(false)}>
            {t('labels.chiudi')}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default TVComponent;
